import '../scss/main.scss';
// import { CONFIG } from './libs/configs.js'; // Removed Wijmo config import

try {
  // lucideはログイン後のページでのみ読み込まれるため、存在チェックを行う
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }

  // Removed Wijmo initialization
  // if (typeof wijmo !== 'undefined') {
  //   wijmo.setLicenseKey(CONFIG.WIJMO_LICENSE_KEY);
  // } else {
  //   console.warn('wijmoが読み込まれていません');
  // }
} catch (e) {
  console.error('初期化中にエラーが発生しました:', e);
}

document.addEventListener('DOMContentLoaded', function () {
  // DOM要素
  const sidebar = document.getElementById('sidebar');
  const toggleSidebarBtn = document.getElementById('toggle-sidebar');

  // サイドバーの折りたたみ機能（要素が存在する場合のみ実行）
  if (toggleSidebarBtn && sidebar) {
    toggleSidebarBtn.addEventListener('click', function () {
      sidebar.classList.toggle('collapsed');

      // ロゴテキストの更新
      const logoText = document.getElementById('logo-text');
      if (logoText) {
        if (sidebar.classList.contains('collapsed')) {
          logoText.textContent = 'ACS';
        } else {
          logoText.textContent = 'Apostro\nCashless\nService';
        }
      }
    });
  }
});
